<template>
  <v-app>
    <!--begin::Head-->
    <!--
    <div class="kt-login__head">
      <span class="kt-login__signup-label">{{
        $t("AUTH.GENERAL.NO_ACCOUNT")
      }}</span
      >&nbsp;&nbsp;
      <router-link
        class="kt-link kt-login__signup-link"
        :to="{ name: 'register' }"
      >
        {{ $t("AUTH.GENERAL.SIGNUP_BUTTON") }}
      </router-link>
    </div>
    -->
    <!--end::Head-->

    <!--begin::Body-->
    <div class="kt-login__body">
      <!--begin::Signin-->
      <div class="kt-login__form">
        <div class="kt-login__title">
          <h3>Ingreso</h3>
        </div>

        <!--begin::Form-->
        <b-form class="kt-form" @submit.stop.prevent="onSubmit">
            <!--
            <div role="alert" class="alert alert-info">
                <div class="alert-text">
                Use account <strong>admin@demo.com</strong> and password
                <strong>demo</strong> to continue.
                </div>
            </div>
            -->
          

          <b-form-group
            id="example-input-group-1"
            label="Email"
            label-for="example-input-1"
          >
            <b-form-input
              id="example-input-1"
              name="example-input-1"
              v-model="$v.form.email.$model"
              :state="validateState('email')"
              aria-describedby="input-1-live-feedback"
            ></b-form-input>

            <b-form-invalid-feedback id="input-1-live-feedback">
              El email es requerido.
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            id="example-input-group-2"
            label="Contraseña"
            label-for="example-input-2"
          >
            <b-form-input
              type="password"
              id="example-input-2"
              name="example-input-2"
              v-model="$v.form.password.$model"
              :state="validateState('password')"
              aria-describedby="input-2-live-feedback"
            ></b-form-input>

            <b-form-invalid-feedback id="input-2-live-feedback">
              La contraseña es requerida.
            </b-form-invalid-feedback>
          </b-form-group>

          <!--begin::Action-->
          <div class="kt-login__actions">
            <a href="#" @click="showDialog = true" class="kt-link kt-login__link-forgot">
              {{ $t("AUTH.FORGOT.TITLE") }}
            </a>
            <b-button
              type="submit"
              id="kt_submit"
              class="btn btn-primary btn-elevate kt-login__btn-primary"
            >
              Ingresar
            </b-button>
          </div>
          <!--end::Action-->
        </b-form>
        <!--end::Form-->

        <!--begin::Divider-->
        <!--
        <div class="kt-login__divider">
          <div class="kt-divider">
            <span></span>
            <span>OR</span>
            <span></span>
          </div>
        </div>
        -->
        <!--end::Divider-->

        <!--begin::Options-->
        <!--
        <div class="kt-login__options">
          <a href="#" class="btn btn-primary kt-btn">
            <i class="fab fa-facebook-f"></i>
            Facebook
          </a>

          <a href="#" class="btn btn-info kt-btn">
            <i class="fab fa-twitter"></i>
            Twitter
          </a>

          <a href="#" class="btn btn-danger kt-btn">
            <i class="fab fa-google"></i>
            Google
          </a>
        </div>
        -->
        <!--end::Options-->
      </div>
      <!--end::Signin-->
    </div>
    <!--end::Body-->
    <v-dialog v-model="showDialog" max-width="600px">
        <v-card >
            <v-card-title class="headline">Recuperar contraseña</v-card-title>
            <v-card-text>
                <v-container>
                    <v-form ref="form">
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="email" label="Correo electrónico" required></v-text-field>
                        </v-col>
                    </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn color="blue darken-1" @click="showDialog = false" >Cancelar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" @click="sendForgotPassword" >Enviar recuperación</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </v-app>
</template>

<style lang="scss" scoped>
.kt-spinner.kt-spinner--right:before {
  right: 8px;
}
</style>

<script>

//import { LOGIN, LOGOUT } from "@/store/auth.module";

import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";

export default {
  components:{
  },
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      // Remove this dummy login info
      form: {
        email: "",
        password: ""
      },
      email: undefined,
      showDialog: false,
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(3)
      }
    }
  },
  methods: {
    sendForgotPassword()
    {
      var vm = this;
      this.axios({
        url: 'password_forgot',
        method: 'POST',
        data: {
          email: this.email
        }
      }).then( response => {
        vm.$bvToast.toast('Se ha enviadó un email con las instruccoines para recuperar su contraseña si el email existe en el sistema', {
            title: `Notificación`,
            variant: 'success',
            solid: true,
            toaster: 'b-toaster-bottom-center'
        });
        vm.email = undefined;
        vm.showDialog = false;
      }).catch( error => {
        vm.$bvToast.toast('Ha ocurrido un error', {
            title: `Error`,
            variant: 'danger',
            solid: true,
            toaster: 'b-toaster-bottom-center'
        });
        vm.email = undefined;
        vm.showDialog = false;
      });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null,
        password: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.$v.form.email.$model;
      const password = this.$v.form.password.$model;

      // clear existing errors
      //this.$store.dispatch('passport/signout');

      // set spinner to submit button
      const submitButton = document.getElementById("kt_submit");
      submitButton.classList.add(
        "kt-spinner",
        "kt-spinner--light",
        "kt-spinner--right"
      );

      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch('passport/login', { username: email, password })
          // go to which page after successfully login
          .then(() => this.$router.push({ name: "ordenes" }))
          .catch( () => {
            this.$bvToast.toast("Credenciales incorrectas", {
              title: `Alerta`,
              variant: 'warning',
              solid: true,
              toaster: 'b-toaster-bottom-center'
            });
          });

        submitButton.classList.remove(
          "kt-spinner",
          "kt-spinner--light",
          "kt-spinner--right"
        );
      }, 500);
    },
  },
  computed: {
    
    backgroundImage() {
      return process.env.BASE_URL + "assets/media/bg/bg-4.jpg";
    }
  },
  created(){
    if( this.$route.query.session ){
      switch(this.$route.query.session){
        default:
          console.log('Sesión cerrada correctamente');
          this.$bvToast.toast("Sesión cerrada correctamente", {
            title: `Información`,
            variant: 'info',
            solid: true,
            toaster: 'b-toaster-bottom-center'
          });
          break;
      }
    }
    if( this.$route.query.error_code ){
      switch(this.$route.query.error_code){
        default:
          console.log('Tiempo de sesión expirada o No autorizado');
          break;
      }
    }
  }
};
</script>
